module.exports = "\r\n .popup-wrap {z-index:10;}\r\n .overlay{z-index:9; background: rgba(0, 0, 0, 0.9) !important;}"